import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import steps from '../../../../components/steps/steps'
import * as requiredUrls from '../../../../utils/appointment.url'
import {
  Loading
} from 'element-ui'

export default {
  name: 'chooseUnit',
  components: { BreadCrumb, steps },
  data () {
    return {
      activeName: '0',
      typeList: [],
      loading: null,
    }
  },
  methods: {
    toNext (item) {
      if (item.resPlatform == '1' && item.pcShow == '1') {
        window.location.href = item.pcShowUrl
      } else {
        sessionStorage.setItem('businessCode', item.businessCode) // 保存业务编号
        this.$router.push({
          path: '/reservation',
          query: {
            unitSeq: this.$route.query.unitSeq,
            hallSeq: this.$route.query.hallSeq
          }
        })
      }
    },
    toLast () {
      this.$router.push({
        path: '/chooseUnit',
        query: {
          hallSeq: this.$route.query.hallSeq
        }
      })
    },
    getTypeList () {
      requiredUrls.getReserveTreeList({
        unitSeq: this.$route.query.unitSeq,
        pageRowNum: 999
      }, 'post').then(res => {
        if (+res.status === 200) {
          this.typeList = res.data.dataList
        } else {
          this.$message.error(res.desc)
        }
        this.loading.close()
      }).catch(err => {
        console.log(err)
        this.$message.error(err)
        this.loading.close()
      })
    }
  },
  mounted () {
    this.loading = Loading.service({
      fullscreen: true
    })
    this.getTypeList()
  }
}
